/**
 * Chemistry Experiment Helpers
 * 
 * Phase 5: Pure functions for CRUD operations on reaction steps
 * 
 * These helpers provide immutable updates to ChemExperimentState,
 * ensuring that state changes are predictable and traceable.
 */

import { ChemExperimentState, ReactionStep } from './types';

/**
 * Add a new reaction step to the experiment
 */
export function addReactionStep(
  experiment: ChemExperimentState,
  step: ReactionStep
): ChemExperimentState {
  return {
    ...experiment,
    steps: [...(experiment.steps || []), step],
  };
}

/**
 * Update an existing reaction step
 */
export function updateReactionStep(
  experiment: ChemExperimentState,
  updated: ReactionStep
): ChemExperimentState {
  const steps = experiment.steps || [];
  return {
    ...experiment,
    steps: steps.map((s) => (s.id === updated.id ? updated : s)),
  };
}

/**
 * Delete a reaction step by ID
 */
export function deleteReactionStep(
  experiment: ChemExperimentState,
  stepId: string
): ChemExperimentState {
  const steps = experiment.steps || [];
  return {
    ...experiment,
    steps: steps.filter((s) => s.id !== stepId),
  };
}

/**
 * Generate a unique ID for a new reaction step
 */
export function generateStepId(): string {
  return `step-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;
}

